interface Option {
  key?: string;
  label: string;
  value: string;
}

export const DEATH_OPTIONS: Array<Option> = [
  {
    key: "1",
    label: "Abortion",
    value: "abortion",
  },
  {
    key: "2",
    label: "Acidosis",
    value: "acidosis",
  },
  {
    key: "3",
    label: "Bacterial (Clostridia, E.Coli, Pasteurellosis, Salmonella, Mycoplasma)",
    value: "bacterial",
  },
  {
    key: "4",
    label: "Bloat",
    value: "bloat",
  },
  {
    key: "5",
    label: "Brain / nervous condition",
    value: "brain-nervous-condition",
  },
  {
    key: "6",
    label: "BVD",
    value: "BVD",
  },
  {
    key: "7",
    label: "Cardiovascular condition",
    value: "cardiovascular-condition",
  },
  {
    key: "8",
    label: "Coccidiosis",
    value: "coccidiosis",
  },
  {
    key: "9",
    label: "Displaced Abomasum",
    value: "displaced-abomasum",
  },
  {
    key: "10",
    label: "Dystocia",
    value: "dystocia",
  },
  {
    key: "11",
    label: "Fluke",
    value: "fluke",
  },
  {
    key: "12",
    label: "Fly strike",
    value: "fly-strike",
  },
  {
    key: "13",
    label: "Grass staggers / hypomagnesaemia",
    value: "hypomagnesaemia",
  },
  {
    key: "14",
    label: "IBR",
    value: "IBR",
  },
  {
    key: "15",
    label: "Johnes",
    value: "johnes",
  },
  {
    key: "16",
    label: "Ketosis",
    value: "ketosis",
  },
  {
    key: "17",
    label: "Lameness",
    value: "lameness",
  },
  {
    key: "18",
    label: "Leptospirosis",
    value: "leptospirosis",
  },
  {
    key: "19",
    label: "Limb fracture",
    value: "limb-fracture",
  },
  {
    key: "20",
    label: "Listeria",
    value: "listeria",
  },
  {
    key: "21",
    label: "Lungworm",
    value: "lungworm",
  },
  {
    key: "22",
    label: "Mastitis",
    value: "mastitis",
  },
  {
    key: "23",
    label: "Metritis",
    value: "metritis",
  },
  {
    key: "24",
    label: "Milk fever / hypocalcaemia",
    value: "hypocalcaemia",
  },
  {
    key: "25",
    label: "Mineral / vitamin imbalance",
    value: "mineral-vitamin-imbalance",
  },
  {
    key: "26",
    label: "Orf",
    value: "orf",
  },
  {
    key: "27",
    label: "Pneumonia",
    value: "pneumonia",
  },
  {
    key: "28",
    label: "Poisoning",
    value: "poisoning",
  },
  {
    key: "29",
    label: "Predation",
    value: "predation",
  },
  {
    key: "30",
    label: "Prolapse",
    value: "prolapse",
  },
  {
    key: "31",
    label: "Rotavirus",
    value: "rotavirus",
  },
  {
    key: "32",
    label: "Scour / diarrhoea",
    value: "diarrhoea",
  },
  {
    key: "33",
    label: "Septicaemia",
    value: "septicaemia",
  },
  {
    key: "34",
    label: "Spinal disease",
    value: "spinal-disease",
  },
  {
    key: "35",
    label: "TB",
    value: "tuberculosis",
  },
  {
    key: "36",
    label: "Teat / udder condition",
    value: "udder-condition",
  },
  {
    key: "37",
    label: "Twin lamb disease",
    value: "twin-lamb-disease",
  },
  {
    key: "38",
    label: "Twisted gut",
    value: "twisted-gut",
  },
  {
    key: "39",
    label: "Unknown",
    value: "unknown",
  },
  {
    key: "40",
    label: "Wire",
    value: "wire",
  },
  {
    key: "41",
    label: "Wound / injury",
    value: "injury",
  },
];
